<div class="tool-content-container">
  <div class="tool-description">
    Select a <instruction-step-link link="cohort" text="Cohort" />, a College, a
    <instruction-step-link link="program" text="Program" />, the range for High
    School GPA [Default: 0-5]
    <i
      class="fa-solid fa-circle-info tooltipIcon"
      matTooltip="Default gives all possible values."
      matTooltipPosition="right"
    ></i
    >, a UWF Year
    <i
      class="fa-solid fa-circle-info tooltipIcon"
      matTooltip="UWFYear1 - UWFYear4: Gives the top 25 most enrolled courses for the selected year."
      matTooltipPosition="right"
    ></i
    >, a Term
    <i
      class="fa-solid fa-circle-info tooltipIcon"
      matTooltip="Multiple terms can be selected. Gives an overall top 25 DWF count for the selected terms"
      matTooltipPosition="right"
    ></i
    >, a Course Number
    <i
      class="fa-solid fa-circle-info tooltipIcon"
      matTooltip="Not all courses will be available based on the selected year and term."
      matTooltipPosition="right"
    ></i
    >, and click submit to generate results for apr/graduation/summary.

    <!-- <b class="instructions-title"
      >To generate results for apr/graduation/summary:</b
    ><br />
    Step 1 <i class="fa-solid fa-arrow-right"></i> Select a
    <instruction-step-link link="cohort" text="Cohort" />
    <br />
    Step 2 <i class="fa-solid fa-arrow-right"></i> Select a College<br />
    Step 3 <i class="fa-solid fa-arrow-right"></i> Select a
    <instruction-step-link link="program" text="Program" />
    <br />
    Step 4 <i class="fa-solid fa-arrow-right"></i> Select the range for High
    School GPA [Default: 0-5]
    <i
      class="fa-solid fa-circle-info tooltipIcon"
      matTooltip="Default gives all possible values."
      matTooltipPosition="right"
    ></i>
    <br />
    Step 5 <i class="fa-solid fa-arrow-right"></i> Select a UWF Year
    <i
      class="fa-solid fa-circle-info tooltipIcon"
      matTooltip="UWFYear1 - UWFYear4: Gives the top 25 most enrolled courses for the selected year."
      matTooltipPosition="right"
    ></i
    ><br />
    Step 6 <i class="fa-solid fa-arrow-right"></i> Select a Term
    <i
      class="fa-solid fa-circle-info tooltipIcon"
      matTooltip="Multiple terms can be selected. Gives an overall top 25 DWF count for the selected terms"
      matTooltipPosition="right"
    ></i
    ><br />
    Step 7 <i class="fa-solid fa-arrow-right"></i> Select a Course Number
    <i
      class="fa-solid fa-circle-info tooltipIcon"
      matTooltip="Not all courses will be available based on the selected year and term."
      matTooltipPosition="right"
    ></i
    ><br />
    Step 8 <i class="fa-solid fa-arrow-right"></i> Click on the submit button -->
    <br /><br />
  </div>

  <div class="chartjs-container" [class.mat-elevation-z8]="true" *ngIf="data">
    <div class="chart-title-with-btn-icon">
      <span>The Most Frequently Enrolled Courses by Program</span>
      <button
        matTooltip="Save chart as image"
        mat-icon-button
        aria-label="Chart snap icon"
        (click)="
          dataService.exportChartJsAsPNG(
            'ftic-course-dwf-apr-chart',
            'ftic-course-dwf-apr-chart'
          )
        "
      >
        <mat-icon>photo_camera</mat-icon>
      </button>
    </div>
    <p class="chartjs-subtitle">
      Cohort:{{ data.selected_cohort }}-{{ data.selected_program }}-{{
        data.selected_terms.join(', ')
      }}
    </p>
    <canvas id="ftic-course-dwf-apr-chart">{{ fticCourseDwfAprChart }}</canvas>
  </div>

  <div class="chartjs-container" [class.mat-elevation-z8]="true" *ngIf="data">
    <div class="chart-title-with-btn-icon">
      <span>Course Grades by APR Based on Selected Course</span>
      <button
        matTooltip="Save chart as image"
        mat-icon-button
        aria-label="Chart snap icon"
        (click)="
          dataService.exportChartJsAsPNG(
            'apr-first-year-course-grades-chart',
            'apr-first-year-course-grades-chart'
          )
        "
      >
        <mat-icon>photo_camera</mat-icon>
      </button>
    </div>
    <p class="chartjs-subtitle">
      Cohort:{{ data.selected_cohort }}-{{ data.selected_program }}-{{
        data.selected_year
      }}-{{ data.selected_course }}
    </p>
    <canvas id="apr-first-year-course-grades-chart">{{
      aprFticCourseGradesChart
    }}</canvas>
  </div>

  <div class="chartjs-container" [class.mat-elevation-z8]="true" *ngIf="data">
    <div class="chart-title-with-btn-icon">
      <span>Trend of passing rates for Courses based on Program</span>
      <button
        matTooltip="Save chart as image"
        mat-icon-button
        aria-label="Chart snap icon"
        (click)="
          dataService.exportChartJsAsPNG(
            'pass-rate-enrollment-chart',
            'pass-rate-enrollment-chart'
          )
        "
      >
        <mat-icon>photo_camera</mat-icon>
      </button>
    </div>
    <p class="chartjs-subtitle">
      Selected:{{ data.selected_program }}-{{ data.selected_course }}
    </p>
    <canvas id="pass-rate-enrollment-chart">{{
      passRateEnrollmentChart
    }}</canvas>
  </div>

  <back-button></back-button>
</div>
